'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray2 = require('babel-runtime/helpers/slicedToArray');

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _preact = require('preact');

var _jsCookie = require('js-cookie');

var _jsCookie2 = _interopRequireDefault(_jsCookie);

var _functional = require('../../utils/functional');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PushItem = function (_Component) {
  (0, _inherits3.default)(PushItem, _Component);

  function PushItem(props) {
    (0, _classCallCheck3.default)(this, PushItem);

    var _this = (0, _possibleConstructorReturn3.default)(this, (PushItem.__proto__ || Object.getPrototypeOf(PushItem)).call(this, props));

    _this.state = {
      loading: false,
      productData: null
    };

    _this.handleQuantityChange = _this.handleQuantityChange.bind(_this);
    _this.handleRemove = _this.handleRemove.bind(_this);
    return _this;
  }

  (0, _createClass3.default)(PushItem, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.fetchProductData();
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps) {
      var _this2 = this;

      if (this.props.cartItems !== prevProps.cartItems) {
        this.fetchProductData();

        var totalNonComplimentaryValue = this.props.cartItems.reduce(function (acc, item) {
          if (!item.properties || item.properties._complimentary !== 'true') {
            return acc + item.quantity * item.price;
          }
          return acc;
        }, 0);

        if (totalNonComplimentaryValue < this.props.complimentaryMinPrice) {
          var complimentaryItems = this.props.cartItems.filter(function (item) {
            return item.properties._complimentary;
          });

          complimentaryItems.forEach(function () {
            var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(complimentaryItem) {
              return _regenerator2.default.wrap(function _callee$(_context) {
                while (1) {
                  switch (_context.prev = _context.next) {
                    case 0:
                      _context.next = 2;
                      return _this2.props.removeItem(complimentaryItem.id);

                    case 2:
                    case 'end':
                      return _context.stop();
                  }
                }
              }, _callee, _this2);
            }));

            return function (_x) {
              return _ref.apply(this, arguments);
            };
          }());
        }
      }
    }
  }, {
    key: 'fetchProductData',
    value: function fetchProductData() {
      var urlToCheck = 'https://' + window.location.hostname + '/?view=push-cart-items';
      var xhr = new XMLHttpRequest();
      xhr.open('GET', urlToCheck, true);

      xhr.onload = function () {
        if (xhr.status >= 200 && xhr.status < 300) {
          // Parse JSON data
          var data = JSON.parse(xhr.responseText);
          this.setState({ productData: data.products });
        } else {
          // Handle errors if the request fails
          console.error('The request failed!');
        }
      }.bind(this);

      xhr.onerror = function () {
        // Handle network errors
        console.error('Network Error');
      };

      // Send the request
      xhr.send();
    }
  }, {
    key: 'triggerModal',
    value: function triggerModal() {
      (0, _functional.getElement)('[data-modal="complimentary"]').classList.add('mod-Modal-active');
    }
  }, {
    key: 'handleQuantityChange',
    value: function () {
      var _ref2 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2(quantity, item) {
        return _regenerator2.default.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                this.setState({
                  loading: true
                });

                _context2.next = 3;
                return this.props.updateQuantityOfItem(quantity, item);

              case 3:

                this.setState({
                  loading: false
                });

              case 4:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function handleQuantityChange(_x2, _x3) {
        return _ref2.apply(this, arguments);
      }

      return handleQuantityChange;
    }()
  }, {
    key: 'handleRemove',
    value: function () {
      var _ref3 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee3() {
        var currentGwpRemoved, newGwpRemoved;
        return _regenerator2.default.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                this.setState({
                  loading: true
                });

                /* eslint-disable */
                if (this.props.item.properties['__giftWithPurchase'] === true || this.props.item.properties['_automatic_gift'] === 'true') {
                  currentGwpRemoved = _jsCookie2.default.get('gwpRemoved-1') || '';
                  newGwpRemoved = currentGwpRemoved + ',' + this.props.item.variant_id;

                  // Set a cookie to remember the most recent removed GWP

                  _jsCookie2.default.set('gwpRemoved-1', newGwpRemoved, { expires: 1 });
                }
                /* eslint-enable */

                _context3.next = 4;
                return this.props.removeItem();

              case 4:

                this.setState({
                  loading: false
                });

              case 5:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function handleRemove() {
        return _ref3.apply(this, arguments);
      }

      return handleRemove;
    }()
  }, {
    key: 'render',
    value: function render(props, state, context) {
      var _this3 = this;

      var item = props.item;


      var isGiftItem = window.freeGiftId === item.id;
      var isPromoItem = item.properties.__giftWithPurchase;
      var isComplimentaryItem = item.properties._complimentary;
      var isAutomaticGiftItem = item.properties._automatic_gift;

      var matchingVariantData = this.state.productData && this.state.productData.find(function (variant) {
        return variant.variant_id === item.variant_id;
      });
      var hasCompareAtPrice = matchingVariantData && matchingVariantData.variant_compare_at_price > matchingVariantData.variant_price;

      var hidePurchaseOptions = matchingVariantData && matchingVariantData.hide_purchase_options || false;

      return (0, _preact.h)(
        'div',
        {
          className: 'crt-PushItem' + (state.loading ? ' crt-PushItem-loading' : '')
        },
        hidePurchaseOptions ? (0, _preact.h)(
          'span',
          { className: 'crt-PushItem_ImageContainer' },
          (0, _preact.h)('img', {
            className: 'crt-PushItem_Image',
            src: item.image,
            width: '90',
            loading: 'lazy'
          })
        ) : (0, _preact.h)(
          'a',
          { className: 'crt-PushItem_ImageContainer', href: item.url },
          (0, _preact.h)('img', {
            className: 'crt-PushItem_Image',
            src: item.image,
            width: '90',
            loading: 'lazy'
          })
        ),
        (0, _preact.h)(
          'div',
          { className: 'crt-PushItem_Content' },
          (0, _preact.h)(
            'h5',
            { className: 'crt-PushItem_Title' },
            hidePurchaseOptions ? (0, _preact.h)(
              'span',
              { className: 'crt-PushItem_TitleLink crt-PushItem_TitleLink-disabled' },
              item.product_title
            ) : (0, _preact.h)(
              'a',
              { className: 'crt-PushItem_TitleLink', href: item.url },
              item.product_title
            )
          ),
          this.isARecurringOrder || isPromoItem || isComplimentaryItem || isAutomaticGiftItem ? (0, _preact.h)(
            'p',
            { className: 'crt-PushItem_Price' },
            (0, _preact.h)(
              'span',
              {
                className: 'crt-PushItem_PriceStrike igComparePrice',
                'data-product-id': item.product_id
              },
              (0, _functional.formatMoney)(item.price)
            ),
            (0, _preact.h)(
              'span',
              {
                className: 'crt-PushItem_ActualPrice igPrice',
                'data-product-id': item.product_id
              },
              isPromoItem || isComplimentaryItem ? (0, _functional.formatMoney)(0) : (0, _functional.formatMoney)(parseInt(item.properties['properties[_ro_unformatted_price]'], 10))
            )
          ) : (0, _preact.h)(
            'p',
            { className: 'crt-PushItem_Price' },
            hasCompareAtPrice && (0, _preact.h)(
              'span',
              {
                className: 'crt-PushItem_PriceStrike igComparePrice',
                'data-product-id': item.product_id
              },
              (0, _functional.formatMoney)(matchingVariantData.variant_compare_at_price)
            ),
            (0, _preact.h)(
              'span',
              {
                className: 'crt-PushItem_ActualPrice igPrice' + (hasCompareAtPrice ? ' crt-PushItem_Price-onSale' : ''),
                'data-product-id': item.product_id
              },
              (0, _functional.formatMoney)(item.price)
            )
          ),
          this.isARecurringOrder && (0, _preact.h)(
            'p',
            { className: 'crt-PushItem_Recurring' },
            this.recurringOrderString
          ),
          !isGiftItem && (0, _preact.h)(
            'div',
            { className: 'crt-PushItem_Controls' },
            !isPromoItem && !isComplimentaryItem && !isAutomaticGiftItem && (0, _preact.h)(
              'select',
              {
                className: 'crt-PushItem_Select',
                onChange: function onChange(e) {
                  return _this3.handleQuantityChange(parseInt(e.target.value, 10), props.item);
                }
              },
              this.quantities.map(function (amount) {
                amount = amount + 1;

                return (0, _preact.h)(
                  'option',
                  {
                    value: amount,
                    selected: amount === item.quantity
                  },
                  amount
                );
              })
            ),
            !isComplimentaryItem ? (0, _preact.h)(
              'button',
              {
                className: 'crt-PushItem_Remove',
                type: 'button',
                onClick: this.handleRemove
              },
              'Remove'
            ) : (0, _preact.h)(
              'button',
              {
                className: 'crt-PushItem_ComplimentaryChange btn-Secondary',
                type: 'button',
                onClick: this.triggerModal
              },
              'Change'
            )
          ),
          isAutomaticGiftItem && (0, _preact.h)(
            'ul',
            { className: 'crt-PushItem_Properties' },
            Object.entries(item.properties).map(function (_ref4) {
              var _ref5 = (0, _slicedToArray3.default)(_ref4, 2),
                  key = _ref5[0],
                  value = _ref5[1];

              if (key.startsWith('_') || key === '') {
                return null;
              }

              return (0, _preact.h)(
                'li',
                { key: key, className: 'crt-PushItem_Property' },
                (0, _preact.h)(
                  'strong',
                  null,
                  key,
                  ':\xA0'
                ),
                value
              );
            })
          )
        ),
        (0, _preact.h)(
          'div',
          { className: 'crt-PushItem_Loading' },
          (0, _preact.h)(
            'svg',
            {
              viewBox: '0 0 120 30',
              xmlns: 'http://www.w3.org/2000/svg',
              fill: '#fff'
            },
            (0, _preact.h)(
              'circle',
              { cx: '15', cy: '15', r: '15' },
              (0, _preact.h)('animate', {
                attributeName: 'r',
                from: '15',
                to: '15',
                begin: '0s',
                dur: '0.8s',
                values: '15;9;15',
                calcMode: 'linear',
                repeatCount: 'indefinite'
              }),
              (0, _preact.h)('animate', {
                attributeName: 'fill-opacity',
                from: '1',
                to: '1',
                begin: '0s',
                dur: '0.8s',
                values: '1;.5;1',
                calcMode: 'linear',
                repeatCount: 'indefinite'
              })
            ),
            (0, _preact.h)(
              'circle',
              { cx: '60', cy: '15', r: '9', fillOpacity: '.3' },
              (0, _preact.h)('animate', {
                attributeName: 'r',
                from: '9',
                to: '9',
                begin: '0s',
                dur: '0.8s',
                values: '9;15;9',
                calcMode: 'linear',
                repeatCount: 'indefinite'
              }),
              (0, _preact.h)('animate', {
                attributeName: 'fill-opacity',
                from: '.5',
                to: '.5',
                begin: '0s',
                dur: '0.8s',
                values: '.5;1;.5',
                calcMode: 'linear',
                repeatCount: 'indefinite'
              })
            ),
            (0, _preact.h)(
              'circle',
              { cx: '105', cy: '15', r: '15' },
              (0, _preact.h)('animate', {
                attributeName: 'r',
                from: '15',
                to: '15',
                begin: '0s',
                dur: '0.8s',
                values: '15;9;15',
                calcMode: 'linear',
                repeatCount: 'indefinite'
              }),
              (0, _preact.h)('animate', {
                attributeName: 'fill-opacity',
                from: '1',
                to: '1',
                begin: '0s',
                dur: '0.8s',
                values: '1;.5;1',
                calcMode: 'linear',
                repeatCount: 'indefinite'
              })
            )
          )
        )
      );
    }
  }, {
    key: 'quantities',
    get: function get() {
      return (0, _functional.range)(this.props.maxQuantity);
    }
  }, {
    key: 'isARecurringOrder',
    get: function get() {
      return this.props.item != null && this.props.item.properties != null && 'properties[frequency_num]' in this.props.item.properties;
    }
  }, {
    key: 'recurringOrderString',
    get: function get() {
      return 'A recurring order of ' + this.props.item.properties['properties[discounted_price]'] + ' every ' + this.props.item.properties['properties[frequency_num]'] + ' ' + this.props.item.properties['properties[frequency_type_text]'];
    }
  }]);
  return PushItem;
}(_preact.Component); // eslint-disable-next-line no-unused-vars


exports.default = PushItem;